/**
 * collection-toolbar.js
 * Handles the "Sort by" select and the mobile "Filters" toggle
 * rendered by sections/collection-toolbar.liquid. Works whether
 * or not sections/collection-product-grid.liquid is present.
 */
(function () {
  var sortSelect = document.getElementById('SortBy');
  var filterToggle = document.getElementById('CollectionFilterToggle');
  var filterPanel = document.getElementById('CollectionFilters');
  var facetForm = document.getElementById('FacetFiltersForm');

  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var value = sortSelect.value;

      if (facetForm) {
        // Keep the filter form's hidden sort_by input in sync, then submit
        // so sort + active filters are applied together.
        var hidden = document.getElementById('FacetFiltersFormSortBy');
        if (hidden) {
          hidden.value = value;
        }
        facetForm.submit();
        return;
      }

      // Fallback: no filter form on the page, just update the URL.
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', value);
      window.location.href = url.toString();
    });
  }

  if (filterToggle && filterPanel) {
    filterToggle.addEventListener('click', function () {
      var isOpen = filterPanel.classList.toggle('is-open');
      filterToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      document.body.classList.toggle('collection-filters-open', isOpen);
    });
  }
})();
